import Vue from 'vue'
import Router from 'vue-router'
// import Layout from '@/layout/default'
import Layout from '@/layout/NoHeadAndFoot'
import Index from '@/views/home/Index.vue'
import Index2_h5 from '@/views/home/Index_h5.vue'
import systemRounter from '@/areas/systemmanage/router'
// import personalCenterRounter from '@/areas/PersonalCenter/router'
Vue.use(Router)
const originalReplace = Router.prototype.replace;
Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch(err => err);
};
export const constantRouters = [
    {
      path: '/pdfMarker',
      name: 'pdfMarker',
      component: () => import('@/components/WaterMarker/pdfMarker.vue'),
      meta: { title: 'PDF附件预览', needAuth: false, layout: 'default' },
    },
    {
      path: '/wordMarker',
      name: 'wordMarker',
      component: () => import('@/components/WaterMarker/wordMarker.vue'),
      meta: { title: 'word文档水印测试', needAuth: false, layout: 'default' },
    },
    //用于页面刷新,借助新页面重定向
    {
        path: '/redirect',
        component: Layout,
        hidden: true,
        children: [{
            path: '/redirect/:path*',
            component: () =>
                import('@/views/redirect/Index')
        }],
        meta: { needAuth: false, layout: 'default' },
    },
    {
        path: '/',
        name: 'Index',
        component: Index,
        meta: { title: '煤炭地质云', needAuth: false, layout: 'default' }
    },
    // {
    //     path: '/ProjectStatistics',
    //     name: 'ProjectStatistics',
    //     component: () =>
    //         import('@/views/KJGL/ProjectInitiation/ProjectStatistics.vue'),
    //     meta: { title: '项目统计新', needAuth: false, layout: 'default'},
    // },
    //src\views\KJGL\ProjectInitiation\ProjectStatistics.vue
    {
        path: '/ProjectQualityReport',
        name: 'ProjectQualityReport',
        component: () =>
            import('@/areas/GCProject/ProjectQuality/report.vue'),
        meta: { title: '质量验收报告', needAuth: false, layout: 'default' },
    },
    {
        path: '/DesignReportInfo',
        name: 'DesignReportInfo',
        component: () =>
            import('@/areas/GCProject/Project/ProjectDesign/DesignReport/DesignReportInfo.vue'),
        meta: { title: '设计报告编制', needAuth: false, layout: 'default' },
    },
    // {
    //     path: '/PointSurveyRecord',
    //     name: 'PointSurveyRecord',
    //     component: () =>
    //         import('@/areas/GCProject/DrillHole/PointSurveyRecord.vue'),
    //     meta: { title: '导点测井斜原始记录表导入', needAuth: false, layout: 'default', noHeadAndFoot: true },
    // },
    // {
    //     path: '/TemperatureRecord',
    //     name: 'TemperatureRecord',
    //     component: () =>
    //         import('@/areas/GCProject/DrillHole/TemperatureRecord.vue'),
    //     meta: { title: '点测井温原始记录表导入', needAuth: false, layout: 'NoHeadAndFoot'},
    // },
    {
        path: '/ProjectHistoryList',
        name: 'ProjectHistoryList',
        component: () =>
            import('@/views/KJGL/ProjectHistory/ProjectHistoryList'),
        meta: { title: '科研项目', needAuth: false, layout: 'default' },
    },//D:\Project\地质云\DZYWebUI\src\views\KJGL\ProjectHistory\ProjectHistoryList.vue
    {
        path: '/reportDetail',
        name: 'ProjectQualityReport',
        component: () =>
            import('@/areas/GCProject/ProjectDetails/ProjectQuality/report.vue'),
        meta: { title: '质量验收报告详情', needAuth: false, layout: 'default' },
    },
    // {
    //     path: '/IndustryDynamic_detail',
    //     name: 'IndustryDynamic_detail',
    //     component: () =>
    //         import('@/views/News/IndustryDynamic_detail.vue'),
    //     meta: { title: '新闻详情', needAuth: false, layout: 'default' },
    // },
    // {
    //     path: '/TradeLeads_detail',
    //     name: 'TradeLeads_detail',
    //     component: () =>
    //         import('@/views/News/TradeLeads_detail.vue'),
    //     meta: { title: '供求详情', needAuth: false, layout: 'default' },
    // },
    //***************************** h5适配新增 ********************************
    {
        path: '/science_h5',
        name: 'science_h5',
        component: () =>
            import('@/views/science/scienceBase_h5.vue'),
        meta: { title: '科普基地', needAuth: false, layout: 'default', noHeadAndFoot: true, keepAlive: true },
    },
    {
        path: '/scienceEdit_h5',
        name: 'scienceEdit_h5',
        component: () =>
            import('@/views/science/Manage/components/scienceEdit_h5.vue'),
        meta: { title: '新增', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/sciencedetail_h5',
        name: 'sciencedetail_h5',
        component: () =>
            import('@/views/science/science_detail_h5.vue'),
        meta: { title: '人物详情', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/sciencenewsdetail_h5',
        name: 'sciencenewsdetail_h5',
        component: () =>
            import('@/views/science/science_newsdetail_h5.vue'),
        meta: { title: '新闻详情', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/ProjectOneDrawing_h5',
        name: 'ProjectOneDrawing_h5',
        component: () =>
            import('@/areas/GCProject/ProjectOneDrawing/ProjectOneDrawing_h5.vue'),
        meta: { title: '项目一张图', needAuth: true, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/index_h5',
        name: 'index_h5',
        component: () =>
            import('@/areas/GCProject/ProjectStatistics/index_h5.vue'),
        redirect: '/ProjectWeeklyReport_h5',
        children: [{
            path: '/Charts_h5',
            name: 'Charts_h5',
            component: () =>
                import('@/areas/GCProject/Charts/Charts_h5.vue'),
            meta: { title: '统计报表', needAuth: true, layout: 'default', noHeadAndFoot: true },
        },
        {
            path: '/ProjectWeeklyReport_h5',
            name: 'ProjectWeeklyReport_h5',
            component: () =>
                import('@/areas/GCProject/ProjectStatistics/ProjectWeeklyReport_h5.vue'),
            meta: { title: '项目周报统计', needAuth: true, layout: 'default', noHeadAndFoot: true },

        }],
        meta: { title: '项目统计', needAuth: true, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/GCProjectManagement_h5',
        name: 'GCProjectManagement_h5',
        component: () =>
            import('@/areas/GCProject/Project/ProjectList_h5.vue'),
        meta: { title: '项目创建', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/ProjectTeChnicalViewList_h5',
        name: 'ProjectTeChnicalViewList_h5',
        component: () =>
            import('@/areas/GCProject/ProjectTeChnicalView/ProjectTeChnicalViewList_h5.vue'),
        meta: { title: '项目技术管理视图', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/ProjectTeChnicalView_h5',
        name: 'ProjectTeChnicalView_h5',
        component: () =>
            import('@/areas/GCProject/ProjectTeChnicalView/ProjectTeChnicalView_h5.vue'),
        meta: { title: '项目技术管理视图详情', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/knowledge_h5',
        name: 'knowledge_h5',
        component: () =>
            import('@/views/knowledge/knowledge_h5.vue'),
        meta: { title: '知识共享', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/DiskList_h5',
        name: 'DiskList_h5',
        component: () =>
            import('@/views/disk/DiskList_h5.vue'),
        meta: { title: 'CGC云盘', needAuth: true, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/share/:shareCode',
        name: 'ShareAccess',
        component: () =>
            import('@/views/disk/ShareAccess.vue'),
        meta: { title: '分享文件', needAuth: false, layout: 'default' },
    },
    {
        path: '/GeologicalQuery_h5',
        name: 'GeologicalQuery_h5',
        component: () =>
            import('@/views/Geological/GeologicalQuery_h5.vue'),
        meta: { title: '地质特征在线查询', needAuth: false, layout: 'nohendandfoot', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/Equipment_h5',
        name: 'Equipment_h5',
        component: () =>
            import('@/views/Equipment/Equipment_list_h5.vue'),
        meta: { title: '仪器设备', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/ScienceAchievements_h5',
        name: 'ScienceAchievements_h5',
        component: () =>
            import('@/views/KJGL/ScienceAchievements/List_h5.vue'),
        meta: { title: '科技成果', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/ProjectEchart_h5',
        name: 'ProjectEchart_h5',
        component: () =>
            import('@/views/KJGL/ProjectInitiation/ProjectEchart_h5'),
        meta: { title: '图表', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/ProjectInitiation_h5',
        name: 'ProjectInitiation_h5',
        component: () =>
            import('@/views/KJGL/ProjectInitiation/ProjectInitiation_h5'),
        meta: { title: '申请书', needAuth: false, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/Implementation_h5',
        name: 'Implementation_h5',
        component: () =>
            import('@/views/KJGL/Implementation/Implementation_h5'),
        meta: { title: '项目进展', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: "/footprint_h5",
        name: "footprint_h5",
        component: () =>
            import('@/areas//PersonalCenter/views/components/footprint_h5.vue'),
        meta: {
            title: "操作足迹", needAuth: false, layout: 'default', noHeadAndFoot: true
        },
    },
    {
        path: '/register_h5',
        name: 'register_h5',
        component: () =>
            import('@/views/home/Register_h5'),
        meta: { title: '注册', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/login_h5',
        name: 'login_h5',
        component: () =>
            import('@/views/home/Login_h5'),
        hidden: true,
        needAuth: false,
        meta: { title: '登录', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/IndustryDynamic_detail_h5',
        name: 'IndustryDynamic_detail_h5',
        component: () =>
            import('@/views/News/IndustryDynamic_detail_h5.vue'),
        meta: { title: '新闻详情', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/Index2_h5',
        name: 'Index2_h5',
        component: Index2_h5,
        meta: {
            title: '煤炭地质云', needAuth: false, layout: 'default', noHeadAndFoot: true, keepAlive: true, //此组件需要被缓存
        },
    },
    {
        path: "/EditPWD_h5",
        name: "EditPWD_h5",
        component: () => import('@/areas/PersonalCenter/views/editPWD_h5.vue'),
        meta: { title: "修改密码", needAuth: false, layout: 'default', noHeadAndFoot: true }
    },
    {
        path: "/ForgetPWD_h5",
        name: "ForgetPWD_h5",
        component: () => import('@/areas/PersonalCenter/views/forgetPWD_h5.vue'),
        meta: { title: "忘记密码", needAuth: false, layout: 'default', noHeadAndFoot: true }
    },
    {
        path: "/myFavorite_h5",
        name: "myFavorite_h5",
        component: () => import('@/areas/PersonalCenter/views/components/myFavorite_h5.vue'),
        meta: { title: "我的收藏", needAuth: false, layout: 'default', noHeadAndFoot: true }
    },
    {
        path: "/myCloudStorage_h5",
        name: "myCloudStorage_h5",
        component: () => import('@/areas//PersonalCenter/views/components/myCloudStorage_h5.vue'),
        meta: { title: "我的云盘", needAuth: false, layout: 'default', noHeadAndFoot: true }
    },
    {
        path: "/TradeLeads_detail_h5",
        name: "TradeLeads_detail_h5",
        component: () => import('@/views/News/TradeLeads_detail_h5.vue'),
        meta: { title: "供求信息", needAuth: false, layout: 'default', noHeadAndFoot: true }
    },
    {
        path: '/application_h5',
        name: 'application_h5',
        component: () =>
            import('@/views/KJGL/ProjectInitiation/Projectapplication_h5.vue'),
        meta: { title: '项目申请', needAuth: true, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/groupapplication_h5',
        name: 'groupapplication_h5',
        component: () =>
            import('@/views/KJGL/GroupProjectInitiation/GroupProjectapplication_h5.vue'),
        meta: { title: '集团项目申请书详情', needAuth: true, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },

    {
        path: '/ContractList_h5',
        name: 'ContractList_h5',
        component: () =>
            import('@/views/KJGL/Contract/ContractList_h5.vue'),
        meta: { title: '合同管理', needAuth: true, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/ContractAduitList_h5',
        name: 'ContractAduitList_h5',
        component: () =>
            import('@/views/KJGL/Contract/ContractAduitList_h5.vue'),
        meta: { title: '合同审核', needAuth: true, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/ContractManage_h5',
        name: 'ContractManage_h5',
        component: () =>
            import('@/views/KJGL/Contract/ContractManage_h5.vue'),
        meta: { title: '合同信息详情', needAuth: true, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/ProjectAuditList_h5',
        name: 'ProjectAuditList_h5',
        component: () =>
            import('@/views/KJGL/ProjectInitiation/ProjectAuditList_h5'),
        meta: { title: '申报审核', needAuth: false, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/ProjectChangeList_h5',
        name: 'ProjectChangeList_h5',
        component: () =>
            import('@/views/KJGL/ProjectChange/ProjectChangeList_h5.vue'),
        meta: { title: '项目变更', needAuth: true, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/ProjectChangeAuditList_h5',
        name: 'ProjectChangeAuditList_h5',
        component: () =>
            import('@/views/KJGL/ProjectChange/ProjectChangeAuditList_h5.vue'),
        meta: { title: '变更审核', needAuth: true, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/ProjectAcceptance_h5',
        name: 'ProjectAcceptance_h5',
        component: () =>
            import('@/views/KJGL/ProjectAcceptance/ProjectAcceptance_h5.vue'),
        meta: { title: '项目验收', needAuth: true, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/ProjectAcceptanceAduitList_h5',
        name: 'ProjectAcceptanceAduitList_h5',
        component: () =>
            import('@/views/KJGL/ProjectAcceptance/ProjectAcceptanceAduitList_h5.vue'),
        meta: { title: '验收审核', needAuth: true, layout: 'default', noHeadAndFoot: true, isMobile: true },
    },
    {
        path: '/ImplementationAudit_h5',
        name: 'ImplementationAudit_h5',
        component: () =>
            import('@/views/KJGL/Implementation/ImplementationAudit_h5'),
        meta: { title: '进展审核', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    {
        path: '/ImplementationAudit',
        name: 'ImplementationAudit',
        component: () =>
            import('@/views/KJGL/Implementation/ImplementationAudit'),
        meta: { title: '进展审核', needAuth: false, layout: 'default', noHeadAndFoot: true },
    },
    //***************************** h5适配新增 *********************************
    {
        path: '/login',
        name: 'login',
        component: () =>
            import('@/views/home/Login'),
        hidden: true,
        needAuth: false,
        meta: { title: '登录', needAuth: false, layout: 'default' },
    },
    {
        path: '/register',
        name: 'register',
        component: () =>
            import('@/views/home/Register'),
        meta: { title: '注册', needAuth: false, layout: 'default' },
    },
    // {
    //     path: '/Personalclouddisk',
    //     name: 'Personalclouddisk',
    //     component: () =>
    //         import('@/areas/PersonalCenter/views/components/Personalclouddisk'),
    //     meta: { title: '个人云盘', needAuth: false, layout: 'default' },
    // },
    {
        path: '/ProjectEchart',
        name: 'ProjectEchart',
        component: () =>
            import('@/views/KJGL/ProjectInitiation/ProjectEchart'),
        meta: { title: '图表', needAuth: false, layout: 'default' },
    },
    {
        path: '/Equipment',
        name: 'Equipment',
        component: () =>
            import('@/views/Equipment/Equipment_list'),
        meta: { title: '设备管理', needAuth: false, layout: 'default' },
    },
    {
        path: '/TaskList',
        name: 'TaskList',
        component: () =>
            import('@/views/KJGL/GroupTask/TaskList'),
        meta: { title: '业绩目标目录', needAuth: false, layout: 'default' },
    },
    {
        path: '/AuditProcess',
        name: 'AuditProcess',
        component: () =>
            import('@/views/AuditProcess/AuditProcess'),
        meta: { title: '审核流程管理', needAuth: false, layout: 'default' },
    },
    {
        path: '/404',
        name: '404',
        component: () =>
            import('@/views/errorpage/404'),
        hidden: true,
        meta: { title: '404页面', needAuth: false, layout: 'default' },
    },
    {
        path: '/403',
        name: '403',
        component: () =>
            import('@/views/errorpage/403'),
        hidden: true,
        meta: { title: '403页面', needAuth: false, layout: 'default' },
    },
    {
        path: '/5001',
        name: '5001',
        component: () =>
            import('@/views/errorpage/5001'),
        hidden: true,
        meta: { title: '5001页面', needAuth: false, layout: 'default' },
    },
    {
        path: '/5002',
        name: '5002',
        component: () =>
            import('@/views/errorpage/5002'),
        hidden: true,
        meta: { title: '5002页面', needAuth: false, layout: 'default' },
    },
    {
        path: '/5003',
        name: '5003',
        component: () =>
            import('@/views/errorpage/5003'),
        hidden: true,
        meta: { title: '5003页面', needAuth: false, layout: 'default' },
    },
    {
        path: '/ShuiWenDiZhiFuZhuJiSuan',
        name: 'ShuiWenDiZhiFuZhuJiSuan',
        component: () =>
            import('@/views/Utilities/ShuiWenDiZhiFuZhuJiSuan.vue'),
        meta: { title: '水文地质辅助计算', needAuth: false, layout: 'default' },
    },
    {
        path: '/GeologicalQuery',
        name: 'GeologicalQuery',
        component: () =>
            import('@/views/Geological/GeologicalQuery.vue'),
        meta: { title: '地质特征在线查询', needAuth: false, layout: 'default' },
    },
    {
        path: '/sciencenewsdetail',
        name: 'sciencenewsdetail',
        component: () =>
            import('@/views/science/science_newsdetail.vue'),
        meta: { title: '新闻详情', needAuth: false, layout: 'default' },
    },
    {
        path: '/sciencedetailList',
        name: 'sciencedetailList',
        component: () =>
            import('@/views/science/science_detail.vue'),
        meta: { title: '人物文章列表', needAuth: false, layout: 'default' },
    },
    {
        path: '/sciencedetail',
        name: 'sciencedetail',
        component: () =>
            import('@/views/science/science_detail.vue'),
        meta: { title: '人物详情', needAuth: false, layout: 'default' },
    },
    {
        path: '/Bindingphonenumber',
        name: 'Bindingphonenumber',
        component: () =>
            import('@/components/User/Bindingphonenumber.vue'),
        meta: { title: '绑定手机号', needAuth: false, layout: 'default' },
    },
    {
        path: '/Comingsoon',
        name: 'Comingsoon',
        component: () =>
            import('@/views/home/Comingsoon.vue'),
        meta: { title: '敬请期待', needAuth: false, layout: 'default' },
    },
    {
        path: '/Test',
        name: 'Test',
        component: () =>
            import('@/components/Charts/LineChart.vue'),
        meta: { title: '绑定测试', needAuth: false, layout: 'default' },
    },
    {
        path: '/download',
        name: 'download',
        component: () =>
            import('@/views/Download/download.vue'),
        meta: { title: '煤炭地质云APP', needAuth: false, layout: 'nohendandfoot' },
    },

    {
        path: '/video',
        name: 'video',
        component: () =>
            import('@/layout/components/header/video.vue'),
        meta: { title: '视频预览', needAuth: false, layout: 'nohendandfoot' },
    },

    // {
    //     path: '/KnowledgeSharing',
    //     name: 'KnowledgeSharing',
    //     component: () =>
    //         import('@/areas/PersonalCenter/views/KnowledgeSharing.vue'),
    //     meta: { title: '测试页面', needAuth: false, layout: 'default' },
    // },
    // {
    //     path: '/PersonalCenter',
    //     name: 'PersonalCenter',
    //     component: () =>
    //         import('@/areas//PersonalCenter/views/PersonalCenter.vue'),
    //     meta: { title: '个人中心', needAuth: false, layout: 'default' },
    //     redirect: '/personalInfo',
    //     children: [
    //         {
    //             path: "/personalInfo",
    //             name: "personalInfo",
    //             component: () => import('@/areas//PersonalCenter/views/components/personalInfo.vue'),
    //             meta: {
    //                 title: "个人资料"
    //             }
    //         },
    //         {
    //             path: "/myFavorite",
    //             name: "myFavorite",
    //             component: () => import('@/areas//PersonalCenter/views/components/myFavorite.vue'),
    //             meta: {
    //                 title: "我的收藏"
    //             }
    //         },
    //         {
    //             path: "/footprint",
    //             name: "footprint",
    //             component: () => import('@/areas//PersonalCenter/views/components/footprint.vue'),
    //             meta: {
    //                 title: "操作足迹"
    //             }
    //         },
    //         {
    //             path: "/onlineService",
    //             name: "onlineService",
    //             component: () => import('@/areas//PersonalCenter/views/components/onlineService.vue'),
    //             meta: {
    //                 title: "在线客服"
    //             }
    //         },
    //     ]
    // },
]
/** 用户的授权路由 */
export const asyncRouters = systemRounter;

// export const asyncRouters = [];
//404等公共页面
export const route404 = [{
    path: '*',
    redirect: '/404',
}];

const createRouter = () => new Router({
    // scrollBehavior: () => ({ y: 0 }),
    mode: 'history',
    routes: constantRouters,
    // savedPosition 当浏览器前进和后退时会记录页面X轴和Y轴滚动的距离
    scrollBehavior: (to, from, savedPosition) => {
        // 当这个值存在时，触发记忆（距离回滚）
        if (savedPosition) {
            return savedPosition
        }
        return { x: 0, y: 0 }
    }
})

const router = createRouter()
export function resetRouter(currentRouter) {
    const newRouter = createRouter()
    // currentRouter = newRouter
    currentRouter.matcher = newRouter.matcher
}

// router.addRoutes(systemRounter)
export default router



// WEBPACK FOOTER //
// ./src/router/index.js